module.exports = __webpack_public_path__ + "static/media/house-leave.8ede2c7a.svg";